import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const base = 'prose prose-text-sm rounded-full px-2.5 py-0.5 font-medium';
const stroke = 'border-[1.5px] border-neutral-900 text-neutral-900';
const fill = 'bg-neutral-900 text-white';
const fillColor = 'border border-neutral-100 bg-neutral-50 text-neutral-900';
const red = 'bg-primary-600 text-white';

@Component({
  selector: 'app-badge',
  template: '<label [ngClass]="getBadgeClass()"><ng-content></ng-content></label>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeComponent {
  @Input() color: 'stroke' | 'fill' | 'red' | 'fill-color' = 'stroke';

  getBadgeClass(): string {
    return `${base} ${
      this.color === 'stroke'
        ? stroke
        : this.color === 'fill'
        ? fill
        : this.color === 'red'
        ? red
        : fillColor
    }`;
  }
}
